package com.evoapps.evoshift.domain.util

import com.evoapps.evoshift.domain.model.TimeRange
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalTime
import kotlinx.datetime.plus

/**
 * Planned shift times are local ISO timestamps without zone (`2026-02-01T08:00:00`), so they can be
 * compared as strings.
 */
fun TimeRange.overlaps(other: TimeRange): Boolean = start < other.end && other.start < end

/** Minutes between the end of this range and the start of [next] (negative when they overlap). */
fun TimeRange.gapMinutesTo(next: TimeRange): Long =
    (localDateTimeMinutes(next.start) - localDateTimeMinutes(end))

private fun localDateTimeMinutes(iso: String): Long {
    val date = LocalDate.parse(iso.substring(0, 10))
    val time = LocalTime.parseSafe(iso.substringAfter('T').take(5))
    return date.toEpochDays() * 24 * 60 + time.hour * 60L + time.minute
}

/**
 * Start and end timestamps of a shift on [date] running from [startTime] to [endTime] (clock times
 * such as `8:00` or `22:30`); a shift ending at or before it starts ends the next day.
 */
fun plannedTimeRange(date: LocalDate, startTime: String, endTime: String): TimeRange {
    val start = startTime.normalizeTime()
    val end = endTime.normalizeTime()
    val endDate = if (LocalTime.parseSafe(end) <= LocalTime.parseSafe(start)) date.plus(DatePeriod(days = 1)) else date
    return TimeRange(start = "${date}T$start:00", end = "${endDate}T$end:00")
}
